import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik, Form, Field } from 'formik';

import { doResetPassword } from '../../../redux/ducks/auth';
import pageWrapper from '../../containers/AnonPage';
import AuthBox from '../../containers/AuthBox';
import Button from '../../common/Button';
import FormFeedback from '../../common/form/FormFeedback';
import TextInput from '../../common/form/TextInput';
import FormResult from '../../../FormResult';

import './ResetPassword.css';

const yup = require('yup');

function extractNonceToken(searchParams) {
  const matches = searchParams.match(/token=([\d\w]+)/);

  return matches ? matches[1] : null;
}

class ResetPasswordPage extends React.PureComponent {
  render() {
    const { location, history, onSubmit } = this.props;

    const nonceToken = extractNonceToken(location.search);

    if (!nonceToken) {
      return (
        <AuthBox>
          <h3>Missing password reset token</h3>
        </AuthBox>
      );
    }

    return (
      <AuthBox>
        <h2>Reset Password</h2>
        <p>
          To reset the password for your account, enter a new password below. You will then be able
          to log in with your email address and new password.
        </p>

        <Formik
          initialValues={{ password: '', confirmPassword: '', token: nonceToken }}
          onSubmit={(values, { setSubmitting, setStatus }) => {
            const onSuccess = () => {
              setSubmitting(false);
              setStatus(new FormResult(
                  200,
                  'Your password has been reset. Redirecting you to the login page...'
                ));
              setTimeout(() => {
                history.push('/sign-in');
              }, 1500);
            };
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            onSubmit(values.password, values.token, onSuccess, onFailure);
          }}
          validationSchema={yup.object().shape({
            password: yup
              .string()
              .min(8, 'Must be at least 8 characters long')
              .max(256, 'Woah, not longer than 256 characters please!')
              .matches(/[\W\d]+/, 'Must contain at least one number or one special character'),
            confirmPassword: yup
              .string()
              .oneOf([yup.ref('password')], 'Passwords must match if setting a new password'),
          })}
          render={({
            // values,
            // errors,
            // touched,
            status,
            // handleChange,
            // handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <Form>
              <FormFeedback status={status} />

              <Field
                name="password"
                label="New Password"
                type="password"
                autoComplete="new-password"
                component={TextInput}
              />

              <Field
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                autoComplete="confirm-password"
                component={TextInput}
              />

              <Button
                type="submit"
                label="Reset my Password"
                color="primary"
                isActive={isSubmitting}
                isDisabled={isSubmitting}
                size="large"
                isFullWidth
                className="resetPassword-button"
                handler={handleSubmit}
              />
            </Form>
          )}
        />
      </AuthBox>
    );
  }
}

ResetPasswordPage.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    onSubmit: (email, password, onSuccess, onFailure) => {
      dispatch(doResetPassword(email, password, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(connect(undefined, mapDispatchToProps)(ResetPasswordPage));



// WEBPACK FOOTER //
// ./src/components/pages/anon/ResetPassword.jsx